module.exports = __webpack_public_path__ + "img/winerackdog16.50c091b4.jpg";